/* eslint-disable */
export const changeSelectedElementNum = (status) => ({
    type: "CHANGE_SELECTED_ELEMENT_NUM",
    status
});
